/**
 * Query keys for the shared Stripe-Connect payment spine (saved cards + the
 * frontend config + the add-card SetupIntent). API reads remain facility-scoped,
 * but the wallet belongs to the organization: two facilities can resolve to the
 * same connected account, while facilities in different organizations cannot.
 *
 * These keys are intentionally namespaced under `["booking", …]` so that EVERY
 * surface that reads/writes through a facility route (court booking, class enrollment,
 * tournament registration) shares ONE cache slot per facility — a card saved
 * during a booking is the same slot listed during a class enroll or a tournament
 * register. The values match the booking app's historical
 * queryKeys.booking.{paymentMethods,frontendConfig,setupIntent} exactly, so moving
 * the hooks into @bw/shared does NOT shift any cache slot (the ReviewPage
 * remove-card test pins `["booking","payment-methods",facilityId]`).
 */
export const paymentQueryKeys = {
  walletFrontendConfig: () =>
    ["player", "payment-methods", "frontend-config"] as const,
  paymentMethods: (facilityId: string) =>
    ["booking", "payment-methods", facilityId] as const,
  frontendConfig: (facilityId: string) =>
    ["booking", "frontend-config", facilityId] as const,
  setupIntent: (facilityId: string) =>
    ["booking", "setup-intent", facilityId] as const,
} as const;
